import React from "react";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";
import { CARRIERS } from "@/lib/constants";

export default function Carriers() {
    return (
        <div data-testid="carriers-page">
            <SEO
                title="Carriers we work with — Moving Mountains Advisors"
                description="An independent, multi-carrier insurance practice. We match clients to the carrier and product that fits — not a single company's catalog."
            />
            <PageHeader
                eyebrow="Partners"
                title="Carriers we work with."
                subtitle="We represent multiple A-rated carriers so we can match you to the best fit — not a single company's catalog. Availability varies by state and product."
            />
            <section className="mm-section bg-white">
                <div className="mm-container">
                    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
                        {CARRIERS.map((c) => (
                            <div
                                key={c.name}
                                className="mm-carrier-logo group rounded-2xl p-6"
                                data-testid={`carrier-card-${c.slug}`}
                            >
                                <div className="flex h-24 items-center justify-center">
                                    <img
                                        src={c.logo}
                                        alt={c.name}
                                        className="max-h-14 max-w-[80%] object-contain object-center"
                                        loading="lazy"
                                        width="160"
                                        height="60"
                                    />
                                </div>
                                <p className="mt-3 text-sm text-mm-muted leading-relaxed">
                                    {c.blurb}
                                </p>
                            </div>
                        ))}
                    </div>
                    <p className="mt-10 mm-disclaimer max-w-3xl">
                        Logos are property of their respective owners and are used for identification purposes only. Moving Mountains does not publish carrier rankings; carrier selection for any individual client is made on a case-by-case basis by a licensed advisor and is dependent on state, health history, product, and underwriting factors.
                    </p>
                </div>
            </section>
        </div>
    );
}
